// BarChartHelpers.ts
// Reusable chart helpers for axis, font size, and formatting

export function getAxisBottomTickRotation(
  numItems: number,
  threshold = 20,
  rotation = 90,
  defaultRotation = 0,
) {
  return numItems > threshold ? rotation : defaultRotation;
}

export function getAxisFontSize(
  numItems: number,
  min = 8,
  max = 14,
  base = 24,
) {
  return Math.max(min, Math.min(max, base - Math.floor(numItems / 2)));
}

// Add more chart helpers as needed
